/* eslint-disable */
import React, {useState} from "react";
import Checkbox from 'components/commons/Checkbox';
import Switch from 'components/commons/Switch';
import Vspace from 'components/commons/Vspace';
import Group from 'components/commons/Group';
import Button from 'components/commons/Button';
import {Text} from 'components/commons/Typography';
import {Col, Row} from 'components/commons/FlexBoxGrid';
import {I18nTranslator} from "../../../../../../../core/i18n/I18nTranslator";


const OptionsContent = () => {
  // Traduções.
  const TEXT_SELECT = I18nTranslator.t("SELECT");
  const TEXT_ALL = I18nTranslator.t("ALL");
  const TEXT_NONE = I18nTranslator.t("NONE");
  const TEXT_CLIENT = I18nTranslator.t("CLIENT");
  const TEXT_CARRIER = I18nTranslator.t("CARRIER");
  const TEXT_DATE = I18nTranslator.t("DATE");
  const TEXT_HOUR_DOC_ATTACHMENT = I18nTranslator.t("HOUR_DOC_ATTACHMENT");

  const [ activeOptions, setOptions] = useState(false)

  function handleOptions() {
    setOptions(activeOptions === false);
  } 

  return (
    <div className={`wac-featured-popover white hod ${ activeOptions ? 'active' : ''}`}>
      <button 
        onClick={handleOptions}
        className="wac-featured-popover-trigger">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" fill="#FFFFFF"><path d="M64,39A25,25,0,1,0,89,64,25,25,0,0,0,64,39Zm0,44A19,19,0,1,1,83,64,19,19,0,0,1,64,83Z"/><path d="M121,48h-8.93a1,1,0,0,1-.94-.68,49.9,49.9,0,0,0-2-4.85,1,1,0,0,1,.18-1.15L115.62,35a7,7,0,0,0,0-9.9L102.89,12.38a7,7,0,0,0-9.9,0l-6.31,6.31a1,1,0,0,1-1.15.18,49.76,49.76,0,0,0-4.85-2,1,1,0,0,1-.68-.94V7a7,7,0,0,0-7-7H55a7,7,0,0,0-7,7v8.93a1,1,0,0,1-.68.94,49.9,49.9,0,0,0-4.85,2,1,1,0,0,1-1.15-.18L35,12.38a7,7,0,0,0-9.9,0L12.38,25.11a7,7,0,0,0,0,9.9l6.31,6.31a1,1,0,0,1,.18,1.15,49.76,49.76,0,0,0-2,4.85,1,1,0,0,1-.94.68H7a7,7,0,0,0-7,7V73a7,7,0,0,0,7,7h8.93a1,1,0,0,1,.94.68,49.9,49.9,0,0,0,2,4.85,1,1,0,0,1-.18,1.15L12.38,93a7,7,0,0,0,0,9.9l12.73,12.73a7,7,0,0,0,9.9,0l6.31-6.31a1,1,0,0,1,1.15-.18,49.76,49.76,0,0,0,4.85,2,1,1,0,0,1,.68.94V121a7,7,0,0,0,7,7H73a7,7,0,0,0,7-7v-8.93a1,1,0,0,1,.68-.94,49.9,49.9,0,0,0,4.85-2,1,1,0,0,1,1.15.18L93,115.62a7,7,0,0,0,9.9,0l12.73-12.73a7,7,0,0,0,0-9.9l-6.31-6.31a1,1,0,0,1-.18-1.15,49.76,49.76,0,0,0,2-4.85,1,1,0,0,1,.94-.68H121a7,7,0,0,0,7-7V55A7,7,0,0,0,121,48Zm1,25a1,1,0,0,1-1,1h-8.93a7,7,0,0,0-6.6,4.69,43.9,43.9,0,0,1-1.76,4.26,7,7,0,0,0,1.35,8l6.31,6.31a1,1,0,0,1,0,1.41L98.65,111.38a1,1,0,0,1-1.41,0l-6.31-6.31a7,7,0,0,0-8-1.35,43.88,43.88,0,0,1-4.27,1.76,7,7,0,0,0-4.68,6.6V121a1,1,0,0,1-1,1H55a1,1,0,0,1-1-1v-8.93a7,7,0,0,0-4.69-6.6,43.9,43.9,0,0,1-4.26-1.76,7,7,0,0,0-8,1.35l-6.31,6.31a1,1,0,0,1-1.41,0L16.62,98.65a1,1,0,0,1,0-1.41l6.31-6.31a7,7,0,0,0,1.35-8,43.88,43.88,0,0,1-1.76-4.27A7,7,0,0,0,15.93,74H7a1,1,0,0,1-1-1V55a1,1,0,0,1,1-1h8.93a7,7,0,0,0,6.6-4.69,43.9,43.9,0,0,1,1.76-4.26,7,7,0,0,0-1.35-8l-6.31-6.31a1,1,0,0,1,0-1.41L29.35,16.62a1,1,0,0,1,1.41,0l6.31,6.31a7,7,0,0,0,8,1.35,43.88,43.88,0,0,1,4.27-1.76A7,7,0,0,0,54,15.93V7a1,1,0,0,1,1-1H73a1,1,0,0,1,1,1v8.93a7,7,0,0,0,4.69,6.6,43.9,43.9,0,0,1,4.26,1.76,7,7,0,0,0,8-1.35l6.31-6.31a1,1,0,0,1,1.41,0l12.73,12.73a1,1,0,0,1,0,1.41l-6.31,6.31a7,7,0,0,0-1.35,8,43.88,43.88,0,0,1,1.76,4.27,7,7,0,0,0,6.6,4.68H121a1,1,0,0,1,1,1Z"/></svg>
      </button>
      <div className="wac-featured-popover-content">
        <Button onClick={handleOptions} className="wac-featured-drawer-trigger" />
        
        <Text className='s11'>{TEXT_SELECT}</Text>
        <Vspace className='sm' />
        <Group className='g5'>
          <Switch
            id='radio-options-01'
            label={TEXT_ALL}
            type='radio'
            name='radio-group-01'
          />
          <Switch
            id='radio-option-02'
            label={TEXT_NONE}
            type='radio'
            name='radio-group-01'
          />
        </Group>
        <hr className='sm' />
        <Row>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='OS' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='NF' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label={TEXT_CLIENT} />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label={TEXT_CARRIER} />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label={TEXT_DATE} />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Local de embarque' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Hora' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Supervisão' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label={TEXT_HOUR_DOC_ATTACHMENT} />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Classificador' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Hora ult. doc. anexado' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Geld do campo (Fatura)' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Placa' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Manifesto' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Peso' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Emissão CT-e' />
          </Col>
          <Col className='col-xs-6'>
            <Checkbox type='circle' label='Situação' />
          </Col>
        </Row>
    
      </div>
    </div>
  );
};

export default OptionsContent